const messageModalActionsTypes = {
    CLOSE_MESSAGE_MODAL: "CLOSE_MESSAGE_MODAL"
};

export default messageModalActionsTypes;